import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";
import { WeeklyTradingReportFilter } from "../types";

export const getWeeklyClientReport = (
  user: User,
  filter: WeeklyTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getweeklytradingreport",
    params: {
      userid: user.userId,
      option: "C",
      year: filter.year,
      week: filter.yearPart,
    },
  });
};

export default getWeeklyClientReport;
